import React from 'react'
import FlexLayout from '../FlexLayout'
import Text from '../Text'

const section = {
  border: '1px solid black',
  borderBox: 'content-box'
}

function SupplierQueueTicket({ obj }) {
  return (
    <FlexLayout
      direction="column"
      style={{ width: '11cm', height: '9cm', border: '2px solid black' }}
    >
      <FlexLayout
        direction="column"
        justify="around"
        align="center"
        style={{ ...section, height: '10%', fontWeight: 600, fontSize: '18px' }}
      >
        <Text plainText={'Senha'} />
      </FlexLayout>

      <FlexLayout
        direction="column"
        justify="around"
        align="center"
        style={{
          ...section,
          height: '72%',
          fontSize: '7em',
          fontWeight: '600'
        }}
      >
        <Text plainText={obj.password} />
      </FlexLayout>

      <FlexLayout
        direction="column"
        align="start"
        style={{ ...section, height: '18%', fontSize: '13px' }}
      >
        <Text
          plainText={`${obj.supplier_name || '-'} - ${obj.supplier_cnpj}`}
          style={{ margin: '0 0 0 5px' }}
        />
        <Text
          plainText={`Impressão: ${obj.print_date}`}
          style={{ margin: '0 0 0 5px' }}
        />
      </FlexLayout>
    </FlexLayout>
  )
}

export default SupplierQueueTicket
